import React, { Component } from "react";
import axios from "axios";
import { message } from "antd";
import { Form, FormItem, ModalItem, ButtonItem, InputNumberItem } from "../../../../../Components/Items";
import SelectProyectosItem from "../../../../../Components/SelectProyectosItem";

class AgregarControlLogistica extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    proyectoId: null,
    proyectoNombre: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.setState({ proyectoId: null, proyectoNombre: null });
      this.formRef.current?.resetFields();
    }
  }

  onChangeProyecto(proyectoId, proyecto) {
    this.setState({ proyectoId: proyectoId || null, proyectoNombre: proyecto ? proyecto.nombre : null });
  }

  cerrarModal(nuevaFila) {
    this.setState({ loading: false });
    this.props.cerrarAgregarControlLogistica(nuevaFila);
  }

  onFinish(values) {
    const { proyectoId, proyectoNombre } = this.state;

    if (Number(values.min) > Number(values.max)) {
      message.error("Min debe ser menor o igual a Max");
      return;
    }

    const yaExiste = (this.props.proyectosExistentes || []).some((existente) => {
      const existenteId = existente ? existente.toString() : null;
      const nuevoId = proyectoId ? proyectoId.toString() : null;
      return existenteId === nuevoId;
    });
    if (yaExiste) {
      message.error("Ya existe un control para ese proyecto, edítalo en la tabla de Controles.");
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "controlInventario/guardarControlDesdeLogistica",
        {
          empresaId: this.props.empresaId,
          insumoId: this.props.insumoId,
          proyectoId,
          min: values.min,
          max: values.max,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Control guardado");
          this.cerrarModal({
            proyectoId,
            proyectoNombre,
            minPropuesto: null,
            maxPropuesto: null,
            controlId: res.data.controlId,
            min: values.min,
            max: values.max,
            guardando: false,
          });
        } else {
          message.error(res.data.message || "No se pudo guardar el control");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("No se pudo guardar el control");
        this.setState({ loading: false });
      });
  }

  onFinishFailed() {
    message.error("Complete los datos");
  }

  render() {
    return (
      <ModalItem
        title="Agregar Control"
        visible={this.props.visible}
        onCancel={() => this.cerrarModal()}
        spinning={this.state.loading}
      >
        <Form
          ref={this.formRef}
          name="agregarControlLogistica"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Agregar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 4 }}>Proyecto (dejar vacío = General)</div>
            <SelectProyectosItem
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              width="100%"
              placeholder="Proyecto"
              value={this.state.proyectoId}
              onChange={(proyectoId, proyecto) => this.onChangeProyecto(proyectoId, proyecto)}
            />
          </div>
          <FormItem label="Min" name="min" required margin number>
            <InputNumberItem min={0} placeholder="Min" style={{ width: "100%" }} />
          </FormItem>
          <FormItem label="Max" name="max" required margin number>
            <InputNumberItem min={0} placeholder="Max" style={{ width: "100%" }} />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

export default AgregarControlLogistica;
